module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/KnifeAndFork2-7bb65f60f4e6b1d221a5b4fd7fa1f5cb.svg";